export default __webpack_public_path__ + "static/media/icon-card-fuel.025cc47e.svg";